<template>
    <div>
        <v-btn
        v-if="screener.id"
        outline
        small
        color="primary"
        @click="
            openAccessLinkDialogWith(
            $t('screener.save.preview.link.dialog.title'),
            $t('rms.button.continue'),
            $t('rms.button.cancel'),
            DEFINES.PREVIEW_LINK_WARNING.GENERATE,
            'getPreviewLink'
            )
        "
        >{{ $t("screener.save.preview.link.button.title") }}</v-btn
    >
    <ConfirmationDialogBox
      :title="accessLinkDialog.title"
      :dialog="accessLinkDialog.visible"
      :yesBtnText="accessLinkDialog.yesBtnText"
      :noBtnText="accessLinkDialog.noBtnText"
      @confirm="handleConfirmation(accessLinkDialog.action)"
      @cancel="resetAccessLinkDialog"
    >
      <div v-if="accessLinkDialog.content && accessLinkDialog.content.length">
        <div class="subheading grey--text mb-2">Remember</div>
        <ul v-for="item in accessLinkDialog.content" :key="item">
          <li>{{ item }}</li>
        </ul>
      </div>
    </ConfirmationDialogBox>
    </div>
</template>
<script>
import i18n from "@/i18n"
import DEFINES from "@/defines";
import ConfirmationDialogBox from "@/components/dialogBox/DynamicConfirmationBox";
export default {
    props: {
        screener: {
            type: Object,
            default: null
        },
        company:{
            type: Object,
        },
        is_media_available:{
          type:Boolean,
          default:true
        }
    },
    name: "ScreenerPreviewLink",
    data() {
    return {
      accessLinkDialog: {
        visible: false,
        title: null,
        yesBtnText: null,
        noBtnText: null,
        content: null,
        action: null
      },
      magic_link_url: null
    };
  },
  components: {
      ConfirmationDialogBox
  },
    methods: {
      openAccessLinkDialogWith(title, yesBtnText, noBtnText, content, action) {
      if(!this.is_media_available){
        this.$store.dispatch ('app/showMessage', {
          message: i18n.t('vod.save.preview.save_event_first_msg'),
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
        return;
      }
      this.accessLinkDialog.visible = true;
      this.accessLinkDialog.title = title;
      this.accessLinkDialog.yesBtnText = yesBtnText;
      this.accessLinkDialog.noBtnText = noBtnText;
      this.accessLinkDialog.content = content;
      this.accessLinkDialog.action = action;
    },

    resetAccessLinkDialog() {
      this.accessLinkDialog.visible = false;
      this.accessLinkDialog.title = null;
      this.accessLinkDialog.yesBtnText = null;
      this.accessLinkDialog.noBtnText = null;
      this.accessLinkDialog.content = null;
      this.accessLinkDialog.action = null;
    },

    handleConfirmation(handlerName) {
      this[handlerName]();
    },

    async getPreviewLink() {
      await this.$store
        .dispatch("screenerAccessLink/getPreviewLink", {
          screener_id: this.screener.id
        })
        .then(response => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.save.magic.link.generated.successfully"),
            color: "success"
          });
          if (response.preview_link) {
            var uuid = response.preview_link.id;
            var preview_link = `${this.company.domain}/screeners/${this.$route.params.screener_id}/link/${uuid}?mode=simulation`;
            if(this.screener.is_unlisted){
              preview_link += '&rel=nofollow';
            }
            window.open(preview_link, "_blank");
          }
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        })
        .finally(() => {
          this.resetAccessLinkDialog();
        });
    },
    }

}
</script>
